import axios from "axios";

const instance = axios.create({
  baseURL: "https://ethio-bid-auction-system.onrender.com/api",
  withCredentials: true
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default instance;